// import logo from "./logo.svg";/
import "./App.css";
// import Album from "./Album";
// import ScriptBuilder from "./ScriptBuilder";
// import BuffBuilder from "./BuffBuilder";
// import LikeHatesBuilder from "./LikeHatesBuilder";
// import { myItems } from "./data1";
// import StoreBuilder from "./storeBuilder";
// import StoryBuilder from "./storyBuilder";
// import StoreBuilderStatic from "./storeBuilderStatic";
// import RedditCommentsFetcher from "./ImgSearch";
import Website from "./AlbumBu";

function App() {
  return (
    <div className="App">
      {/* <StoryBuilder /> */}
      <Website />
      {/* <RedditCommentsFetcher /> */}
      {/* <StoreBuilder></StoreBuilder> */}
      {/* <StoreBuilderStatic></StoreBuilderStatic> */}
      {/* <Album></Album> */}
      {/* <BuffBuilder></BuffBuilder> */}
      {/*<ScriptBuilder></ScriptBuilder>*/}
      {/* <div style={{ marginLeft: "50px" }}>
        <LikeHatesBuilder items={myItems} />
      </div> */}
    </div>
  );
}

export default App;
